'use client'

import { useState } from 'react'
import { useAuth } from '@/components/auth/auth-provider'
import Sidebar from '@/components/layout/sidebar'
import TicketScanner from '@/components/ticket-scanner'
import { Menu, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

import { SubscriptionProvider } from '@/components/subscription-provider'
import { AICoachFAB } from '@/components/global/ai-coach-fab'
export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const { user, logout } = useAuth()
  const [showScanner, setShowScanner] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const handleLogout = async () => {
    await logout()
  }

  return (
    <SubscriptionProvider>
      <div className="min-h-screen bg-background">
        {/* Sidebar - incluye header móvil y bottom navigation */}
        <Sidebar
          user={user || undefined}
          onLogout={handleLogout}
          onScannerClick={() => {
            setShowScanner(true);
          }}
        />

        {/* Main content */}
        <main className="pt-24 pb-20 md:pt-0 md:pb-0 md:ml-64">
          <div className="p-3 sm:p-4 md:p-6 lg:p-8">
            {children}
          </div>
        </main>

        {/* Scanner Modal */}
        {showScanner && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-background rounded-lg w-full max-w-2xl max-h-[90vh] overflow-hidden relative">
              <div className="flex justify-between items-center p-4 border-b">
                <h2 className="text-lg font-semibold">Escáner de Tickets</h2>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setShowScanner(false)}
                  className="h-8 w-8 p-0"
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
              <div className="overflow-y-auto max-h-[calc(90vh-80px)]">
                <TicketScanner
                  onClose={() => setShowScanner(false)}
                  onTicketProcessed={() => {
                    setShowScanner(false)
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {/* Fabric Component */}
        <AICoachFAB />
      </div>
    </SubscriptionProvider>
  )
}
